// extracted by mini-css-extract-plugin
export default {"top":"WinterPaywall_top__xXVa+","headerWave":"WinterPaywall_headerWave__+vk4E","bottom":"WinterPaywall_bottom__6PsQH"};